import styles from './mamaPlus.module.css'
import { useNavigate } from 'react-router-dom';
import Bildergalerie from '../../components/Bildergalerie/Bildergalerie';
function MamaPlus() {
    const navigate = useNavigate();
    const imgs = [
        {
            path: "uploads/sportmodule/mamaFitness/mama_plus_1.jpg",
            // alt: "",
            // text: "Das hier ist Text1"
        },
        {
            path: "uploads/sportmodule/mamaFitness/mama_plus_2.jpg",
            // alt: "",
            // text: "Das hier ist Text 2"
        }
    ]
    return (
        <section className={styles.container}>
            <h1>MamaPlus Programm</h1>
            <p className={styles.sub}>Prä- und Postnatales Training - Sportlich Aktiv in der Schwangerschaft und nach der Rückbildung</p>
            <div>
                <p>MamaPlus - unser Spezialprogramm für werdende Mütter und Mamis. Von Anfang an...willkommen! - so will der TuS Frauen in dieser besonderern Phase unter sportlichen Gesichtspunkten unterstützen. Mehr Fitness gibt es darum mittwochs von 09:00 - 10:00 oder von 10:00 - 11:00 in der TuS-Vereinshalle: "FitinForm, Mama!", natürlich mit Fokus auf Beckenboden und Co und Babys sind auch erwünscht!</p>
                <p>Wir begleiten Euch werdende Mütter und Mütter nach der Geburt durch diese besondere Lebensphase:</p>
                <ul>
                    <li>Wir ermöglichen es dir <strong>weiterzutrainieren</strong> oder auch trotz der Schwangerschaft dich sportlich angemessen auszupowern</li>
                    <li>Wir begleiten dich durch fachkundige Expertise</li>
                    <li>Wir ermöglichen dir einen sicheren und geschützten Raum für dich und dein Baby</li>
                </ul>
                <p>Das Training ist speziell auf deine Bedürfnisse während dieser besonderen Phase deines Lebens abgestimmt und kann invididuell an deine Bedürfnisse angepasst werden. Nebenbei lernst du vile andere Mamas kennen und findest dadruch Austausch.</p>
            </div>
            <section>
                <h2>Unsere Kurse im Überblick</h2>
                <div className={styles.kurse}>
                    <section className={styles.erlebnis}>
                        <h3>Erlebnissport</h3>
                        <ul>
                            <li>
                                <span className={`${styles.head} ${styles.underline}`}
                                    onClick={() => navigate('/erlebnissport/fitness-und-entspannung#fit-in-form-mama')}
                                    style={{ cursor: 'pointer' }}>Fit in Form - Mama</span>
                            </li>
                            <li>
                                <span className={`${styles.head} ${styles.underline}`}
                                    onClick={() => navigate('/erlebnissport/sport-und-natur#mamafitness-outdoor')}
                                    style={{ cursor: 'pointer' }}>MamaFitness Outdoor</span>
                            </li>
                        </ul>
                    </section>
                    <section className={styles.gesundheit}>
                        <h3>Gesundheitssport</h3>
                        <ul>
                            <li>
                                <span className={`${styles.head} ${styles.underline}`}
                                    onClick={() => navigate('/erlebnissport/fitness-und-entspannung#mamafitness-outdoor-praeventionskurs')}
                                    style={{ cursor: 'pointer' }}>MamaFitness Outdoor - Präventionskurs</span>
                            </li>
                        </ul>
                    </section>
                </div>
            </section>
            <section>
                <h2>Bildergalerie</h2>
                <Bildergalerie images={imgs} />
            </section>
        </section>
    )
}

export default MamaPlus;